import { createRouter, createWebHistory } from 'vue-router'
import VueCookies from 'vue-cookies'
import setWindowTitle from '@/utils/setWindowTitle.js'
import store from '@/store'

const routes = [
  {
    path: '/',
    component: () => import('@/App.vue'),
    children: [
      {
        path: '/',
        name: 'briefings',
        component: () => import('@/views/TopWrapper.vue'),
        meta: {
          title: 'i18n:pages.briefings'
        }
      },
      {
        path: '/profile',
        name: 'profile',
        component: () => import('@/views/ProfileView/index.vue'),
        meta: {
          title: 'i18n:pages.profile'
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginPage.vue'),
    meta: {
      title: 'i18n:pages.login'
    }
  },
  {
    path: '/404',
    name: 'error',
    component: () => import('@/layout/Error404.vue'),
    meta: {
      title: 'i18n:pages.error404'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  }
]

async function getRouterBasePath() {
  try {
    const response = await fetch(window.location.href, { method: 'HEAD' });
    const basePath = response.headers.get('X-Vue-Router-Base');

    return basePath || '/';
  } catch (error) {
    console.error('Error on getting base path from server:', error);
    return '/'; // Fallback
  }
}

async function getRouter () {
  const routerBase = await getRouterBasePath();
  const router = createRouter({
    history: createWebHistory(routerBase),
    routes
  })

  router.afterEach((to, from) => {
    setWindowTitle(to)
  })

  router.beforeEach(async (to, from, next) => {
    if (!store.getters.isAuthorized) {
      if (VueCookies.isKey('X-ID-TOKEN')) {
        store.dispatch('shortLogin', router)
        return next()
      }
      if (to.name === 'login') {
        return next()
      } else {
        return next({ name: 'login', query: { redirect: to.name } })
      }
    } else if (to.name === 'login') {
      return next('/')
    }
    next()
  })

  return router
}

export default getRouter
